export default __webpack_public_path__ + "static/media/button_about_us.1b08fdf6.png";